import { Link } from 'gatsby';
import tw, { styled } from 'twin.macro';
import isPropValid from '@emotion/is-prop-valid';

export const StyledLink = styled(Link, {
  shouldForwardProp: isPropValid,
})<{ isActive: boolean }>`
  ${tw`relative`}
  ${tw`flex items-center justify-center`}
  ${tw`h-[40px] min-w-[40px]`}
  ${tw`rounded`}
  ${tw`text-center text-tag-m text-primary-p1`}
  ${tw`font-inter font-semi-bold`}
  ${tw`hover:bg-secondary-s1 hover:text-neutrals-n1`}

  ${({ isActive }) =>
    isActive && tw`bg-ui-colours-ui3 hover:bg-ui-colours-ui3 hover:text-primary-p1`}
`;
